const Check = () => {
  return (
    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5L4.5 8.5L9.5 1" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default Check
